<template>
    <div class="vertical-timeline-block">
        <div class="vertical-timeline-icon bg-danger">
            <i class="fa fa-times-circle"></i>
        </div>
        <div class="vertical-timeline-content">
            <h5>Отписка от курса</h5>
            <p>{{ action.title }}</p>
            <router-link :to="action.link" class="btn btn-sm btn-warning"> Подробнее</router-link>
            <span class="vertical-date">
                {{ action.date }}
                <small>{{ action.time }}</small>
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ActionsUnSubscribe",
        props: ['action']
    }
</script>

<style scoped>

</style>
